import React from 'react';
import { coinSvg } from '../../../HomeLoans/svg';

import Select from 'react-select';
const configurationTypes = [
    { type: '1 RK', value: '1RK' },
    { type: '1 BHK', value: '1BHK' },
    { type: '1.5 BHK', value: '1.5BHK' },
    { type: '2 BHK', value: '2BHK' },
    { type: '2.5 BHK', value: '2.5BHK' },
    { type: '3 BHK', value: '3BHK' },
    { type: '3.5 BHK', value: '3.5BHK' },
    { type: '4 BHK', value: '4BHK' },
    { type: '4.5 BHK', value: '4.5BHK' },
    { type: '5 BHK', value: '5BHK' },
    { type: 'Villa', value: 'Villa' },
    { type: 'Other', value: 'Other' }
];
const StepOne = ({
    setStep,

    unitConfig,
    handleunitConfigChange,
    prefilledData,

    prefilledUnitConfig,
    prefilledUnitArea,
    handleChange,
    unitArea,
    error
}) => {
    const getDropdownOptions = () => {
        if (prefilledData.length > 1) {
            return prefilledData.map((data) => ({
                label: data?.unitConfiguration,
                value: data?.unitConfiguration
            }));
        }
        return configurationTypes.map((config) => ({
            label: config.type,
            value: config.value
        }));
    };

    return (
        <>
            <div className="flex text-base md:text-lg font-semibold justify-between py-3 ">
                <div className="flex items-center gap-1">
                    <button className="font-semibold">Enquiry</button>
                </div>

                <p>
                    Step{' '}
                    <span className="text-primary text-sm md:text-base">1</span>
                    <span className=" text-xs md:text-sm">/2</span>
                </p>
            </div>
            <div className="flex items-center border rounded-[10px] p-5 ">
                <div>{coinSvg}</div>

                <div className="text-left pl-3">
                    <h1 className="font-bold leading-[1] text-sm md:text-base whitespace-nowrap ">
                        Thank you for your enquiry
                    </h1>
                    <p className=" text-xs md:text-sm text-[#adadad] mt-1">
                        Please share a few more details to help serve you better
                    </p>
                </div>
            </div>
            <div>
                <div className="flex flex-col gap-4">
                    <div className="mb-2 grid grid-cols-1 mt-2 gap-x-7">
                        <div className="mt-4">
                            <h2 className="font-semibold text-left">
                                Unit Configuration
                            </h2>

                            <div className="h-12 lg:h-10 xl:h-[50px]">
                                <Select
                                    placeholder="Select configuration"
                                    options={getDropdownOptions()}
                                    onChange={(val) => {
                                        handleunitConfigChange(val);
                                    }}
                                    value={
                                        prefilledUnitConfig
                                            ? {
                                                  value: prefilledUnitConfig,
                                                  label: prefilledUnitConfig
                                              }
                                            : unitConfig
                                            ? {
                                                  value: unitConfig?.Name,
                                                  label: unitConfig?.displayName
                                              }
                                            : null
                                    }
                                    isDisabled={
                                        prefilledData.length === 1 &&
                                        prefilledUnitConfig
                                    }
                                    styles={{
                                        container: (provided, state) => ({
                                            ...provided,
                                            width: '100%',
                                            color: 'black',
                                            height: '100%'
                                        }),

                                        control: (styles, state) => ({
                                            ...styles,
                                            opacity: '0.95',
                                            height: '100%',
                                            color: 'black',

                                            boxShadow: 'none'
                                        }),
                                        placeholder: (styles) => ({
                                            ...styles,
                                            color: '#adadad',
                                            fontFamily: 'inherit',
                                            fontWeight: 400
                                        })
                                    }}
                                    className={`text-[#adadad] placeholder-[#adadad] font-semibold bg-white text-base text-left rounded-[8px] mt-2  `}
                                />
                            </div>
                        </div>

                        <div className="mt-4">
                            <h2 className="font-semibold text-left">
                                Unit Area (sq. ft)
                            </h2>

                            <div>
                                <input
                                    className="outline-none text-left border rounded-[8px] p-3 mt-2 w-full"
                                    type="text"
                                    placeholder="Unit Area"
                                    value={unitArea}
                                    onChange={handleChange}
                                    disabled={
                                        prefilledData.length === 1 &&
                                        prefilledUnitArea
                                    }
                                />
                                {error && (
                                    <p className="text-red-500 mt-1">{error}</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        className={`w-full text-white p-3 rounded-[10px] disabled:cursor-not-allowed disabled:bg-[#adadad] bg-primary`}
                        onClick={() => setStep((prev) => prev + 1)}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </>
    );
};

export default StepOne;
